import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogClose,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { Body } from "@hypercard/web-components";

type Props = {
  reason: string;
  children: React.ReactNode;
};
export const ReasonDialog = ({ reason, children }: Props) => {
  return (
    <Dialog>
      {children}
      <DialogContent className="sm:min-w-96 sm:max-w-lg">
        <DialogHeader>
          <DialogTitle>Reason</DialogTitle>
        </DialogHeader>
        <DialogDescription className="rounded-md bg-white/10 px-6 py-4">
          <Body size="md" weight="regular" className="text-white/70">
            {`"${reason}"`}
          </Body>
        </DialogDescription>
        <DialogFooter>
          <DialogClose asChild>
            <Button type="button" variant="default" className="min-w-[140px]">
              Understood
            </Button>
          </DialogClose>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
